import { HoldingMethod } from '@blockpulse3/data/shared';

import { AllowedHoldingMethodOption } from './types';

export const allowedHoldingMethods: HoldingMethod[] = Object.values(HoldingMethod).filter(
  (holdingMethod) => holdingMethod !== HoldingMethod.DIRECT,
);

export const defaultHoldingMethodOptions: AllowedHoldingMethodOption[] = allowedHoldingMethods.map(
  (holdingMethod) => {
    return {
      label: holdingMethod.toString(),
      value: holdingMethod,
    };
  },
);
